import type { ColumnsType } from 'antd/lib/table'
import {
  CustomText,
  CustomHeaderText,
  OffsetPreparedNameRow,
  PurchaseEmissionColumn,
  PreviewExtraDataColumn,
  OffsetPreparedNameColumn,
  OffsetPreparedMovileViewColumn,
} from 'src/components'

const purchasePreparedColumns: ColumnsType<any> = [
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Contract'} />,
    responsive: ['sm'],
    render: (_, record) => <CustomText label={record[record?.keys?.identifierField]} />
  },
  {
    title: () => <OffsetPreparedNameRow />,
    responsive: ['sm'],
    render: (_, record) => <OffsetPreparedNameColumn data={record} keys={record?.keys} />,
  },
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Email'} />,
    responsive: ['sm'],
    render: (_, record) => <CustomText label={record[record?.keys?.emailField]} />
  },
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Emission'} />,
    responsive: ['sm'],
    render: (_, record) => <PurchaseEmissionColumn amount={record?.co2AmountField} />
  },
  {
    title: () => <CustomHeaderText text={'developers.OffSet.ExtraData'} isCentered />,
    responsive: ['sm'],
    render: (_, record) => <PreviewExtraDataColumn excelData={record} />
  },

  // Mobile
  {
    title: () => <CustomHeaderText text={'developers.OffSet.Preview'} />,
    responsive: ['xs'],
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return <OffsetPreparedMovileViewColumn data={record} keys={record?.keys} amount={record?.co2AmountField} />
    }
  }
]

export default purchasePreparedColumns
